<script setup>
import { ref, computed, inject } from 'vue';
import StudentGrowth from '@/components/result/MLSRD-2026/StudentGrowth.vue';
import IntroPage from '@/components/result/MLSRD-2026/IntroPage.vue';

// 부모에서 주입받은 데이터
const studentData = inject('studentData');
const loading = inject('loading');

// reportData를 computed로 변경하여 API 데이터 반영
const reportData = computed(() => {
    if (!studentData.value) {
        return {
            region: "서울",
            schoolName: "로딩중...",
            grade: "",
            className: "",
            studentNumber: "",
            gender: "",
            studentName: ""
        };
    }

    const data = studentData.value;
    // 학교급별 학년 표시
    const gradeMap = { 'E': '초', 'M': '중', 'H': '고' };
    const gradeText = `${data.grade_code}`;

    return {
        region: "서울",
        schoolName: data.schul_nm || "",
        grade: gradeText,
        className: data.school_cls || "",
        studentNumber: data.school_num || "",
        gender: data.gender === 'M' ? '남' : data.gender === 'F' ? '여' : '',
        studentName: data.name || ""
    };
});
</script>
<template>
    <div class="slide-inner student-intro"> 
        <IntroPage reportType="student" :reportData="reportData" />
        <p class="result-contact"><img src="@/assets/images/result/tell.png" alt="" width="14" /> 문의 : 서울특별시 교육청 학생역량혁신교육과 (초)02-6033-5933 / (중,고)02-6033-5934</p>
        <StudentGrowth />
    </div>
</template>

<style scoped>
.student-intro { padding-top: 12px; }
/* .slide-inner 가 align-items:center 라서 폭을 채워주지 않으면 가운데로 밀린다 */
.result-contact { width: 100%; align-self: stretch; font-size: 14px; line-height: 1.4; text-align: left; padding-top: 6px; }
.result-contact img { display: inline-block; vertical-align: middle; }
.student-intro :deep(h3) { line-height: 1.3; }
.student-intro :deep(.s-plan-head h4) { padding: 10px; }
.student-intro :deep(.s-plan-head > p) { padding: 8px 0; font-size: 20px; }
.student-intro :deep(.s-plan-table) { font-size: 18px; line-height: 1.4; padding-bottom: 0; }
.student-intro :deep(.s-plan-table .row) { padding: 2px 0; font-size: 18px; line-height: 1.35; }
.student-intro :deep(.s-plan-table .row > p:nth-child(2)),
.student-intro :deep(.s-plan-table .row .test) { padding: 15px 10px 15px 16px; }
.student-intro :deep(.s-plan-table .row .test) { gap: 6px; }
</style>
